import { Injectable } from '@angular/core';


export function nameof<T>(key: keyof T, instance?: T): keyof T {
    return key;
}

@Injectable({
    providedIn: 'root'
})
export class UtilitiesJson {

    static toJsonObject(value: any): any {
        if (typeof value === 'string') {
            try {
                const json = JSON.parse(value);
                if (typeof json == 'object') {
                    return json;
                }
            } catch {
            }

            return {} as any;
        } else {
            return (value ?? {});
        }
    }
    static toJsonArray(value: any): any[] {
        if (typeof value === 'string') {
            try {
                const json = JSON.parse(value);
                if (Array.isArray(json)) {
                    return json;
                }
            } catch {
            }

            return [];
        } else {
            return (value ?? []) as any[];
        }
    }
}
